import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './styles.css';
import Box from '../../components/layout/Box';
import { setLeftNavbarOpen } from '../../state/navigation/actions';

import MenuContent from './MenuContent';
import MenuHeader from './MenuHeader';

const width = 300;

const LeftNavbar = () => {
  const dispatch = useDispatch();

  const leftNavbarOpen = useSelector(
    (state) => state.navigation.leftNavbarOpen,
  );

  const [isOpen, setIsOpen] = useState(leftNavbarOpen);

  useEffect(() => {
    setIsOpen(leftNavbarOpen);
  }, [leftNavbarOpen]);

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev);

    requestAnimationFrame(() => {
      dispatch(setLeftNavbarOpen(!leftNavbarOpen));
    });
  };

  return (
    <Box
      id="leftNavbar"
      className="d-flex flex-column"
      style={{
        top: 56,
        bottom: 0,
        left: 0,
        width: isOpen ? width : 58,
        flexShrink: 0,
      }}
    >
      <MenuHeader isOpen={isOpen} />
      <MenuContent
        isMobile={false}
        isOpen={isOpen}
        handleToggleOpen={handleToggleOpen}
      />
    </Box>
  );
};

export default LeftNavbar;
